import SessionStatus from "./SessionStatus";

/**
 * Master class of Dictionaries
 */
class MasterDictionary {
    constructor() {
        this.getDictionaries();
    }

    /**
     * Fetches all dictionaries
     */
    getDictionaries() {
        const definitions = [
            {name: 'SESSION_MESSAGE', dictionary: SessionStatus},
        ];

        for (let def of definitions) { 
            this[def.name] = {};
            const extracted = this.extract(def.dictionary);
            for (let ext of extracted) {
                this[def.name][ext.name] = ext.val;
            }
        }
    }

    /**
     * Extracts 'status' attr from dictionary object
     * Note: Gets 'customStatus' or 'status' attrs from dictionary
     * @param {Object} dictionaryObj 
     * @returns {Array{Object{name: {String}, val: {*}}}}
     */
    extract(dictionaryObj = {}) {
        try {
            const statusData = dictionaryObj.customStatus ?? dictionaryObj.status ?? false;
            if (!statusData)
                return [];

            let data = [];
            for (let key of Object.keys(statusData)) {
                data.push({
                    name: key,
                    val: statusData[key]
                })
            }
            return data;
        } catch (error) {
            return [];
        }
    }

    /**
     * Checks if status is valid
     * @param {String} identifier 
     * @param {Integer} value
     * @returns {Boolean} 
     */
    isStatusValid(identifier = '', value = '') {
        const requiredStatus = this[identifier] ?? null;
        if (!requiredStatus)
            return false;
        for (let key of Object.keys(requiredStatus)) {
            if (requiredStatus[key] == value)
                return true;
        }
        return false;
    }
}

const masterDictionary = new MasterDictionary()
export default masterDictionary